<template>
  <div class="activity-box">
    <div class="bg text-center">
      <div class="fontWeight-800 fontSize48 bg-title">联盟活动</div>
      <div class="bg-desc color-level4 fontSize16">金标沙龙是由金标联盟主办、玩咖欢聚承办的行业交流活动，活动旨在搭建产业深度对话平台，促进智能终端生态合作共赢。
        沙龙汇聚金标联盟成员——OPPO、vivo、小米、联想等国内领先智能手机厂商代表，与优质开发者及行业伙伴共聚一堂，共同推动智能终端产业生态的繁荣发展。
      </div>
    </div>
    <div class="activity content-1200 relative">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
              v-for="(item,index) in activity"
              :class="['swiper-slide fontWeight-500 text-center fontSize28 color-level2 cursor',{active:current.title === item.title}]"
              :key="index"
              @click="current = item"
          >{{ item.title }}
          </div>
        </div>
        <div v-if="activity.length > 5" class="swiper-button-next"></div>
        <div v-if="activity.length > 5" class="swiper-button-prev"></div>
      </div>
      <reveal-animation :options="{origin:'left',distance:'100px',easing:'ease'}" :key="current.title">
        <div class="activity-content">
          <div class="desc fontSize14 color-level4 text">{{ current.desc }}</div>
          <div class="images">
            <img v-for="(item,index) in current.images" :src="item" :key="index" alt="">
          </div>
        </div>
      </reveal-animation>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"
import 'swiper/dist/css/swiper.css'
import RevealAnimation from "@/components/common/RevealAnimation.vue";
import {singleHomeSever, singleTrendsServer} from "@/common/api-config";

export default {
  components: {RevealAnimation},
  data() {
    return {
      activity: [],
      current: {}
    }
  },
  mounted() {
    this.getActivityList()
    this.initSwiper()
  },
  methods: {
    getActivityList() {
      singleTrendsServer.queryActiveList({}).then(res => {
        if (res.code == 0 && res.data && res.data.length) {
          this.activity = res.data;
          this.current = this.activity.at(0);
          this.$nextTick(() => {
            this.initSwiper()
          })
        } else {
          this.$message.error(res.message);
        }
      });
    },
    initSwiper(initialSlide = 0) {
      new Swiper('.swiper-container', {
        slidesPerView: 5,
        spaceBetween: 16,
        initialSlide, //初始高亮
        direction: 'horizontal',
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        buttonDisabledClass: 'test',
        allowTouchMove: false,  // 禁用触摸滑动
        simulateTouch: false,   // 禁用鼠标模拟触摸（PC端）
        noSwiping: true         // 全局禁用滑动
      });
    },
  }
}
</script>

<style scoped lang="scss">
.activity-box {
  background-color: #12151A;
  position: relative;

  .bg {
    width: 100%;
    height: 440px;
    background-image: url("~@/assets/img/activity/bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    padding-top: 54px;

    &-title {
      background: linear-gradient(359.9999999898547deg, #CEC298 0%, #FFF2C6 52%, #D4C79D 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
      margin-bottom: 24px;
    }
    &-desc {
      display: inline-block;
      width: 893px;
      line-height: 27px;
    }
  }

  .swiper-container {
    background: transparent;
    width: 100%;
    position: absolute;
    top: -80px;

    .swiper-slide.active {
      font-weight: bold;
      color: #CEC298;
    }

    .swiper-button-next, .swiper-button-prev {
      width: 28px;
      height: 28px;
      margin-top: -13px;
      background-size: cover;
    }

    .swiper-button-next {
      background-image: url('~@/assets/img/activity/right-arrow.png');
    }

    .swiper-button-prev {
      background-image: url('~@/assets/img/activity/left-arrow.png');
    }
  }

  .activity-content {
    padding: 60px 0 80px;

    .desc {
      width: 1070px;
      line-height: 24px;
      word-wrap: break-word;
      margin: 0 auto 40px;
    }

    .images {
      width: 1000px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 40px;

      img {
        width: 100%;
        height: 318px;
        border-radius: 8px;
      }
    }
  }

}
</style>
